module.exports = __webpack_public_path__ + "static/dust_mephit-b21253708cc1e93d25e00bde8f0648dd.jpeg";